"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysOffUpdateSchema = exports.DaysOffUpdateScalarSchema = exports.DaysOffCreateSchema = exports.DaysOffCreateScalarSchema = exports.DaysOffPrismaUpdateSchema = exports.DaysOffPrismaCreateSchema = exports.DaysOffSchema = exports.DaysOffScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    dateFrom: zod_1.z.coerce.date(),
    dateTo: zod_1.z.coerce.date(),
    name: zod_1.z.string().min(1, { message: "Name must be between 1 and 50 characters" }).max(50, { message: "Name must be between 1 and 50 characters" }),
}).strict();
const relationSchema = zod_1.z.object({
    merchant: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    merchantId: zod_1.z.string().uuid(),
});
/**
 * `DaysOff` schema excluding foreign keys and relations.
 */
exports.DaysOffScalarSchema = baseSchema;
/**
 * `DaysOff` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.DaysOffSchema = exports.DaysOffScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.DaysOffPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.DaysOffPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    dateFrom: zod_1.z.coerce.date(),
    dateTo: zod_1.z.coerce.date(),
    name: zod_1.z.string().min(1, { message: "Name must be between 1 and 50 characters" }).max(50, { message: "Name must be between 1 and 50 characters" })
}).partial().passthrough();
/**
 * `DaysOff` schema for create operations excluding foreign keys and relations.
 */
exports.DaysOffCreateScalarSchema = baseSchema;
/**
 * `DaysOff` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.DaysOffCreateSchema = exports.DaysOffCreateScalarSchema.merge(fkSchema);
/**
 * `DaysOff` schema for update operations excluding foreign keys and relations.
 */
exports.DaysOffUpdateScalarSchema = baseSchema.partial();
/**
 * `DaysOff` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.DaysOffUpdateSchema = exports.DaysOffUpdateScalarSchema.merge(fkSchema.partial());
